import {
  Button,
  Card, Col, Modal, Row,
} from 'react-bootstrap';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, NumberInput, StringInput } from '../../../../components/Controls';

function calcTxt(params) {
  const {
    x, y, diam, isDim, isDiam,
  } = params;

  const area = `${(isDiam) ? Math.round(Math.PI * (diam / 2) ** 2) : x * y} кв.мм.`;
  const dim = (isDiam) ? ` (діаметр ${diam} мм.)` : `(${x} мм. X ${y} мм.)`;
  return isDim ? `${area} ${dim}` : area;
}

function CalcArea({
  keyParam,
  setKeyParam,
  paramArea,
  setParamVent,
  setArea,
}) {
  const [isDiam, setIsDiam] = useState(paramArea.isDiam);

  return keyParam && (
    <Modal
      show={keyParam}
      onHide={() => {
        setKeyParam('');
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Розрахунок площі перерізу</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0 p-3 my-2">
          <Card.Title>
            Площа перерізу
          </Card.Title>
          <Card.Body className="p-1">
            <Row>
              <Col>
                <Checkbox
                  className="mb-0"
                  value={paramArea.isDiam}
                  label="Круглий переріз"
                  onChange={() => {
                    setIsDiam(!paramArea.isDiam);
                    setParamVent({
                      ...paramArea,
                      isDiam: !paramArea.isDiam,
                      isDim: !paramArea.isDiam,
                      note: calcTxt({
                        ...paramArea,
                        isDiam: !paramArea.isDiam,
                      }),
                    });
                  }}
                />
              </Col>
              <Col>
                <Checkbox
                  className="mb-0"
                  value={paramArea.isDim}
                  label="Зазначити геометричні розміри"
                  onChange={() => setParamVent({
                    ...paramArea,
                    isDiam,
                    isDim: !paramArea.isDim,
                    note: calcTxt({
                      ...paramArea,
                      isDim: !paramArea.isDim,
                    }),

                  })}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              {!isDiam ? (
                <Row>
                  <Col className="d-flex justify-content-around">
                    <div>Висота</div>
                    <div className="ms-2">
                      <NumberInput
                        value={paramArea.x}
                        onChange={(e, v) => {
                          setParamVent({
                            ...paramArea,
                            isDiam,
                            x: v,
                            note: calcTxt({
                              ...paramArea,
                              x: v,
                            }),
                          });
                        }}
                      />
                    </div>
                    <div className="mx-2">
                      мм
                    </div>
                  </Col>
                  <Col className="d-flex justify-content-around">
                    <div className="me-2">Ширина</div>
                    <div>
                      <NumberInput
                        value={paramArea.y}
                        onChange={(e, v) => setParamVent({
                          ...paramArea,

                          isDiam,
                          y: v,
                          note: calcTxt({
                            ...paramArea,
                            y: v,
                          }),
                        })}
                      />
                    </div>
                    <div className="ms-2">
                      мм
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col className="d-flex justify-content-around">
                    <div>Діаметр</div>
                    <div className="ms-2">
                      <NumberInput
                        value={paramArea.diam}
                        onChange={(e, v) => setParamVent({
                          ...paramArea,
                          isDiam,
                          diam: v,
                          note: calcTxt({
                            ...paramArea,
                            diam: v,
                          }),
                        })}
                      />
                    </div>
                    <div className="ms-2">
                      мм
                    </div>
                  </Col>
                  <Col />

                </Row>
              )}
            </Row>
            <Row className="mt-2">
              <StringInput
                value={paramArea.note}
                label="note"
                onChange={(e, v) => setParamVent({
                  ...paramArea,
                  note: v,
                })}
              />
            </Row>
          </Card.Body>
          <Card.Footer className="p-3">
            <div className="d-flex justify-content-start">
              <Button
                className="falcon-info"
                onClick={(e) => {
                  setKeyParam('');
                  setArea(e, paramArea.note);
                }}
              >
                Ok
              </Button>
              <Button
                className="btn-falcon-warning mx-2"
                onClick={() => {
                  setKeyParam('');
                }}
              >
                Скасувати
              </Button>
            </div>
          </Card.Footer>
        </Card>
      </Modal.Body>
    </Modal>
  );
}

CalcArea.propTypes = {
  keyParam: PropTypes.bool.isRequired,
  setKeyParam: PropTypes.func.isRequired,
  paramArea: PropTypes.shape({
    isDim: PropTypes.bool.isRequired,
    isDiam: PropTypes.bool.isRequired,
    diam: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    note: PropTypes.string.isRequired,
  }).isRequired,
  setParamVent: PropTypes.func.isRequired,
  setArea: PropTypes.func.isRequired,
};

export default CalcArea;
